(function () {
  // Vanilla port of the original bundle's per-card carousel init (was in
  // global.js, which is jQuery-free already for this bit but never actually
  // ran because global.js as a whole throws on unrelated jQuery calls
  // earlier in the same file, aborting before reaching this line). Wires up
  // any ".product-card-js" swiper -- product cards with more than one image
  // -- with prev/next arrows and pagination dots.
  //
  // NOTE: Swiper's "uniqueNavElements" auto-scoping (which lets a bare CSS
  // selector string resolve correctly per-instance even with several Swiper
  // instances on one page) only kicks in when the nav/pagination elements
  // are DESCENDANTS of the swiper container. In this markup (matching the
  // original scrape) ".product-button-group" and ".product-pagination" are
  // SIBLINGS of ".product-card-js", not children -- so the bare-selector
  // approach silently resolves to zero elements (Swiper finds >1 global
  // match, can't narrow it to 1 inside its own container, and gives up).
  // Fix: resolve each card's own pagination/nav elements manually via the
  // shared ".card-wrapper" ancestor and pass real DOM elements instead of
  // selector strings, so Swiper doesn't need to guess.
  const initProductCardSwipers = () => {
    document.querySelectorAll(".product-card-js").forEach((slider) => {
      if (slider.classList.contains("swiper-initialized")) return;

      const card = slider.closest(".card-wrapper");
      const paginationEl = card ? card.querySelector(".product-pagination .swiper-pagination") : null;
      const nextEl = card ? card.querySelector(".product-button-group.button-next .swiper-button-next") : null;
      const prevEl = card ? card.querySelector(".product-button-group.button-prev .swiper-button-prev") : null;

      new Swiper(slider, {
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initProductCardSwipers();
    document.addEventListener("shopify:section:load", function () {
      initProductCardSwipers();
    });
  });

  // Exposed so other scripts (e.g. search-drawer.js, which injects fresh
  // product-card markup via a raw innerHTML swap rather than a Shopify
  // section reload) can re-run initialization on demand -- the function
  // is already idempotent (skips anything with "swiper-initialized").
  window.initProductCardSwipers = initProductCardSwipers;
})();
